<template>
  <Bar
    :id="chartId"
    :options="chartOptions"
    :data="chartData"
  />
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chartId: 'bar-chart',
      chartOptions: {
        responsive: true,
        maintainAspectRatio:false,
        scales: {
          y: {
            ticks: {
              max : 3600000,
              min : 0,
              suggestedMax: 1200000,
              // Include a dollar sign in the ticks
              callback: function(value) {
                const sec      = Math.floor(value/1000)%60
                const min      = Math.floor(value/1000/60)
                const timeStr = min + ':' + ( '00' + sec ).slice( -2 )
                return timeStr;
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false, // 凡例は非表示
          }
        }
      }
    }
  }
}
</script>
